import React from 'react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css/autoplay';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  sectionMargins,
  standardTransition,
} from '../styles';
import { Container, SectionHeader, Slider } from './ui';
import CustomerReviewCard from './CustomerReviewCard';
import TrustpilotWidget from './TrustpilotWidget';

const StyledCustomerReviews = styled.section`
  ${sectionMargins()};
  overflow: hidden;
`;

const StyledItems = styled(Slider)`
  max-width: 725px;
  overflow: visible;

  .swiper-slide {
    height: auto;
    opacity: 0.5;
    transition: ${standardTransition('opacity')};

    &.swiper-slide-active {
      opacity: 1;
    }
  }
`;

const StyledItem = styled(CustomerReviewCard)`
  height: 100%;
`;

const StyledFooter = styled.footer`
  margin-top: 30px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-top: 35px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 40px;
  `}
`;

const StyledTrustpilotWidget = styled(TrustpilotWidget)`
  display: inline-flex;
  align-items: center;
  gap: 10px;

  ${minBreakpointQuery.small`
    gap: 12px;
  `}

  ${minBreakpointQuery.large`
    gap: 14px;
  `}
`;

const CustomerReviews = ({ heading, items }) => {
  const sliderOptions = {
    modules: [Autoplay],
    initialSlide: 1,
    spaceBetween: 20,
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  };

  return (
    <StyledCustomerReviews>
      <Container>
        <SectionHeader heading={heading} />
        <StyledItems {...sliderOptions}>
          {items.map((item, id) => (
            <StyledItem key={id} {...item} />
          ))}
        </StyledItems>
        <StyledFooter>
          <StyledTrustpilotWidget />
        </StyledFooter>
      </Container>
    </StyledCustomerReviews>
  );
};
export default CustomerReviews;
